module.exports = __webpack_public_path__ + "static/ideas-ffa24b0f33bed51ba1768db3ce69341b.png";